import {
  GetAppointmentByCodexAppointmentIdQuery,
  GetProviderAppointmentByCodexAppointmentIdQuery,
} from 'graphql/generated/remote-schema-hasura';
import { PreworkItem } from './PreWorkItem';
import { PreworkSymptoms } from './PreworkSymptoms';
import { PreworkSymptomsLocation } from './PreworkSymptomsLocation';

interface PreWorkProps {
  prework?:
    | GetAppointmentByCodexAppointmentIdQuery
    | GetProviderAppointmentByCodexAppointmentIdQuery;
  locale: {
    subjectOfAppointment: string;
    typeofSymptoms: string;
    howLongSymptoms: string;
    rateSeveritySymptoms: string;
    whereSymptoms: string;
    front: string;
    back: string;
    anythingElseYouWouldLikeToShareWithYourProvider: string;
  };
  symptomsLocation: string[] | null | undefined;
}

export const PreworkComponent: React.FC<PreWorkProps> = ({
  prework,
  locale,
}) => {
  return (
    <div className="flex flex-col gap-5 text-base">
      <PreworkItem
        question={locale.subjectOfAppointment}
        answer={
          prework?.getFHIRAppointmentByCodexId.appointment
            ?.subjectOfAppointment as string
        }
      />

      <PreworkSymptoms
        question={locale.typeofSymptoms}
        symptoms={
          prework?.getFHIRAppointmentByCodexId.appointment?.appointmentNotes
            ?.symptomsTypes as string[]
        }
      />

      <PreworkItem
        question={locale.howLongSymptoms}
        answer={
          prework?.getFHIRAppointmentByCodexId.appointment?.appointmentNotes
            ?.howLongQuestion as string
        }
      />

      <PreworkItem
        question={locale.rateSeveritySymptoms}
        answer={
          prework?.getFHIRAppointmentByCodexId.appointment?.appointmentNotes
            ?.severityQuestion as string
        }
      />

      {prework?.getFHIRAppointmentByCodexId.appointment?.appointmentNotes
        ?.anythingElseQuestion && (
        <PreworkItem
          question={locale.anythingElseYouWouldLikeToShareWithYourProvider}
          answer={
            prework?.getFHIRAppointmentByCodexId.appointment?.appointmentNotes
              ?.anythingElseQuestion as string
          }
        />
      )}

      <hr />

      <PreworkSymptomsLocation
        question={locale.whereSymptoms}
        frontLabel={locale.front}
        backLabel={locale.back}
        headLabel={'Head & face'}
        codexPatientId={
          prework?.getFHIRAppointmentByCodexId?.appointment?.codexPatientId ??
          ''
        }
        symptomsLocation={
          prework?.getFHIRAppointmentByCodexId?.appointment?.media
        }
      />
    </div>
  );
};
